<template>
  <div class="page-content">
    <el-tabs v-model="activeName" style="background: #ffffff;margin-top: 20px;" type="card" @tab-click="handleClick">
      <el-tab-pane label="朝阳区" name="second">
        <div style="background-color: #FFF;padding: 20px 60px 40px 60px;margin-top: 16px;margin-bottom: 25px;">
          <div class="table-wrapper">
            <!-- 第一列：只一行，占满高度 -->
            <div class="col col-left">
              朝阳区
            </div>
            <!-- 右侧：多行 -->
            <div class="col col-right">
              <div
                  class="row"
                  v-for="(item, index) in list"
                  :key="index"
              >
                <div class="cell cell-title">
                  {{ item.title }}
                </div>
                <div class="cell cell-content">
                  {{ item.content }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="海淀区" name="first">
        <div style="background-color: #FFF;padding: 20px 60px 40px 60px;margin-top: 16px;margin-bottom: 25px;">
          <div class="table-wrapper">
            <!-- 第一列：只一行，占满高度 -->
            <div class="col col-left">
              海淀区
            </div>
            <!-- 右侧：多行 -->
            <div class="col col-right">
              <div
                  class="row"
                  v-for="(item, index) in list1"
                  :key="index"
              >
                <div class="cell cell-title">
                  {{ item.title }}
                </div>
                <div class="cell cell-content">
                  {{ item.content }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
export default {
  name: "JlzcHome",
  data(){
    return {
      activeName: 'second',
      list: [
        {
          title: '支持高能级展会项目',
          content: '对首次在朝阳区举办的世界商展100强、UFI认证展会等国际知名展会项目，给予最高不超过200万元奖励；对首次在朝阳区举办的其他展览项目，面积达到1万平方米起，给予最高不超过100万元支持'
        },
        {
          title: '支持举办国际会议',
          content: '对在朝阳区举办符合区域重点产业发展方向的国际知名会议，参会人数500人以上且国际代表不少于20%的，给予主办或承办单位50万元资金支持'
        },
        {
          title: '会展业企业能级提升奖励',
          content: '对上一年度营业收入首次达到一定规模的会议、展览及相关服务业企业，给予最高不超过200万元奖励'
        },
        {
          title: '会展业行业奖励',
          content: '对会议、展览及相关服务行业中类，上年度营业收入总量排名前五的企业，给予50万元资金奖励'
        },
        {
          title: 'UFI 国际认证奖励',
          content: '对朝阳区内会展企业，上年度成功通过国际展览业协会（UFI）认证并取得会员单位资格的，或所主办展会获得UFI认证的，给予20万元资金奖励'
        },
        {
          title: '支持会展综合服务平台建设',
          content: '打造会展业专业化、高品质综合服务平台，为展会活动、会展企业提供优质服务，根据产业集聚、服务创新、企业成长等情况进行综合评估，给予最高不超过200万元支持'
        }
      ],
      list1: [
      ]
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    }
  }
}
</script>

<style scoped>
.table-wrapper {
  display: flex;
  border: 1px solid #EBEEF5;
  font-size: 14px;
  line-height: 1.6;
}

/* 左列 */
.col-left {
  width: 120px;
  border-right: 1px solid #EBEEF5;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 右列整体 */
.col-right {
  flex: 1;
  display: flex;
  flex-direction: column;
}

/* 每一行 */
.row {
  display: flex;
  border-bottom: 1px solid #EBEEF5;
}

.row:last-child {
  border-bottom: none;
}

/* 第二列 */
.cell-title {
  width: 220px;
  border-right: 1px solid #EBEEF5;
  padding: 10px;
  box-sizing: border-box;
}

/* 第三列 */
.cell-content {
  flex: 1;
  padding: 10px;
  box-sizing: border-box;
}
</style>
